import { useMedia } from 'react-use';

export const useIsMobile = () => {
  const breakpointMobile = '(max-width: 768px)';
  const isMobile = useMedia(breakpointMobile);

  return isMobile;
};
